import React from "react";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable/NotificationDataTable";
import moment from "moment";
import { useSearchParams } from "react-router-dom";

const NotificationList = (props: any) => {
  const { handleRead, handleDelete } = props
  const [searchParams, setSearchParms] = useSearchParams({ "page": "0", })
  const defaultColumns: any = [
    {
      header: "S.N",
      accessorKey: "user_info.profile.full_name",
      cell: ({ row }: any) => <>{`${searchParams.get("page") === "0" ? "" : searchParams.get("page")}${row?.index + 1}`}</>,
    },
    {
      header: "Title",
      accessorKey: "title",
      cell: NACell,
    },
    {
      header: "Message",
      accessorKey: "description",
      cell: NACell,
    },
    {
      header: "Created",
      accessorKey: "timestamp",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ? moment(getValue()).format('YY-MM-DD HH:mm:ss') : "N/A"}</p>
          </>
        )
      },
    },

    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <div className="w-full whitespace-nowrap text-center -ml-2"><p><span className="cursor-pointer" onClick={() => handleRead(row?.original?.id, row?.original?.unread)}>{row?.original?.unread ? "Read" : "Unread"}</span> <span className="cursor-pointer" onClick={() => handleDelete(row?.original?.id)}>Delete</span></p></div>
        </>
      ),
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.NOTIFICATION}
        queryKey={"notifications"}
        columns={defaultColumns}
        addNewPagePath={""}
        params={{
          deleted:false
        }}
        tableName={"Notifications"}
      />
    </>
  );
};

export default NotificationList;
